module.exports = __webpack_public_path__ + "static/WEDDING E&M-476-24bf56c1548444da4cdd3bd6e64675fd.jpg";